import React, { useEffect, useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { TabView, TabPanel } from "primereact/tabview";
import { InputSwitch } from "primereact/inputswitch";
import addToStructureGif from "../assets/gifs/bit-sized-add-to-structure.gif";
import reorganizeGif from "../assets/gifs/bit-sized-reorganize.gif";
import addIdeaGif from "../assets/gifs/bit-sized-add-idea.gif";
import deleteGif from "../assets/gifs/bit-sized-delete.gif";

interface TipsProps {
  flowId: string | null;
  visible: boolean;
  onClose: () => void;
  activeIndex?: number;
  doNotShowGettingStartedNextTime: boolean;
  onToggleGettingStarted: () => void;
  onOpenVideo: () => void;
}

const Tips: React.FC<TipsProps> = ({
  flowId,
  visible,
  onClose,
  activeIndex = 0,
  doNotShowGettingStartedNextTime,
  onToggleGettingStarted,
  onOpenVideo,
}) => {
  //const storageKey = `tipsDismissed_${flowId || "unknown"}`;
  //const [dismissed, setDismissed] = useState(false);

  // Internal GIF modal states
  const [showStructureHelpGif, setShowStructureHelpGif] = useState(false);
  const [showAddIdeaHelpGif, setShowAddIdeaHelpGif] = useState(false);
  const [showReorganizeHelpGif, setShowReorganizeHelpGif] = useState(false);
  const [showDeleteHelpGif, setShowDeleteHelpGif] = useState(false);

  // useEffect(() => {
  //   const val = localStorage.getItem(storageKey);
  //   setDismissed(val === "true");
  // }, [storageKey]);

  const handleHide = () => {
    // localStorage.setItem(storageKey, "true");
    // setDismissed(true);
    onClose();
  };

  //if (!visible || dismissed) return null;

  return (
    <Dialog
      header="&nbsp;&nbsp;Tips on working with visualizations"
      visible={visible} // && !dismissed}
      modal
      closable
      style={{
        width: "75vw",
        maxWidth: "75vw",
        height: "84vh",
        maxHeight: "84vh",
      }}
      contentStyle={{
        overflow: "hidden",
      }}
      onHide={handleHide}
    >
      <TabView activeIndex={activeIndex}>
        <TabPanel header="Getting Started">
          <div
            style={{
              padding: "20px",
              maxHeight: "calc(84vh - 240px)",
              overflowY: "auto",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "20px",
            }}
          >
            <h3 style={{ textAlign: "center" }}>
              Click the video to get started fast!
            </h3>
            <img
              src="https://firebasestorage.googleapis.com/v0/b/focuspoint-98783.firebasestorage.app/o/images%2Fgetting-started-thumbnail-v4.png?alt=media&token=8df879dc-514a-46cd-9d95-3a8ee3936ef8"
              alt="Getting Started Video"
              width="600"
              onClick={onOpenVideo}
              style={{ cursor: "pointer", borderRadius: "8px" }}
            />
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                padding: "16px",
              }}
            >
              <InputSwitch
                checked={!doNotShowGettingStartedNextTime}
                onChange={onToggleGettingStarted}
              />
              <label
                style={{ fontSize: "16px", cursor: "pointer" }}
                onClick={onToggleGettingStarted}
              >
                Show 'Getting Started' on New Map
              </label>
            </div>
          </div>
        </TabPanel>
        <TabPanel header="Video Guides">
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              gap: "24px",
              padding: "20px",
              maxWidth: "800px",
              margin: "0 auto",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <div style={{ fontWeight: "bold", marginBottom: 8 }}>
                Building structure:
              </div>
              <div
                style={{
                  width: 300,
                  height: 200,
                  background: "#f4f4f4",
                  borderRadius: 8,
                  borderColor: "#136656",
                  borderWidth: 2,
                  borderStyle: "solid",
                  margin: "0 auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => setShowStructureHelpGif(true)}
                title="Click to enlarge"
              >
                <img
                  src={addToStructureGif}
                  alt="Building structure"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 8,
                  }}
                />
              </div>
              <Dialog
                visible={showStructureHelpGif}
                modal
                closable
                header="Building structure..."
                style={{
                  width: "90vw",
                  maxWidth: "1200px",
                  height: "90vh",
                  maxHeight: "90vh",
                }}
                onHide={() => setShowStructureHelpGif(false)}
                contentStyle={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <img
                  src={addToStructureGif}
                  alt="Building structure:"
                  style={{
                    width: "95%",
                    height: "95%",
                    objectFit: "cover",
                    marginTop: 10,
                    borderRadius: 12,
                    borderColor: "#136656",
                    borderWidth: 2,
                    borderStyle: "solid",
                  }}
                />
              </Dialog>
            </div>

            <div style={{ textAlign: "center" }}>
              <div style={{ fontWeight: "bold", marginBottom: 8 }}>
                Add an idea:
              </div>
              <div
                style={{
                  width: 300,
                  height: 200,
                  background: "#f4f4f4",
                  borderRadius: 8,
                  borderColor: "#136656",
                  borderWidth: 2,
                  borderStyle: "solid",
                  margin: "0 auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => setShowAddIdeaHelpGif(true)}
                title="Click to enlarge"
              >
                <img
                  src={addIdeaGif}
                  alt="Add an idea"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 8,
                  }}
                />
              </div>
              <Dialog
                visible={showAddIdeaHelpGif}
                modal
                closable
                header="Add an idea..."
                style={{
                  width: "90vw",
                  maxWidth: "1200px",
                  height: "90vh",
                  maxHeight: "90vh",
                }}
                onHide={() => setShowAddIdeaHelpGif(false)}
                contentStyle={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <img
                  src={addIdeaGif}
                  alt="Add an idea"
                  style={{
                    width: "95%",
                    height: "95%",
                    objectFit: "cover",
                    marginTop: 10,
                    borderRadius: 12,
                    borderColor: "#136656",
                    borderWidth: 2,
                    borderStyle: "solid",
                  }}
                />
              </Dialog>
            </div>

            <div style={{ textAlign: "center" }}>
              <div style={{ fontWeight: "bold", marginBottom: 8 }}>
                Reorganize:
              </div>
              <div
                style={{
                  width: 300,
                  height: 200,
                  background: "#f4f4f4",
                  borderRadius: 8,
                  borderColor: "#136656",
                  borderWidth: 2,
                  borderStyle: "solid",
                  margin: "0 auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => setShowReorganizeHelpGif(true)}
                title="Click to enlarge"
              >
                <img
                  src={reorganizeGif}
                  alt="Reorganize"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 8,
                  }}
                />
              </div>
              <Dialog
                visible={showReorganizeHelpGif}
                modal
                closable
                header="Reorganize..."
                style={{
                  width: "90vw",
                  maxWidth: "1200px",
                  height: "90vh",
                  maxHeight: "90vh",
                }}
                onHide={() => setShowReorganizeHelpGif(false)}
                contentStyle={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <img
                  src={reorganizeGif}
                  alt="Reorganize"
                  style={{
                    width: "95%",
                    height: "95%",
                    objectFit: "cover",
                    marginTop: 10,
                    borderRadius: 12,
                    borderColor: "#136656",
                    borderWidth: 2,
                    borderStyle: "solid",
                  }}
                />
              </Dialog>
            </div>

            <div style={{ textAlign: "center" }}>
              <div style={{ fontWeight: "bold", marginBottom: 8 }}>
                Delete an element:
              </div>
              <div
                style={{
                  width: 300,
                  height: 200,
                  background: "#f4f4f4",
                  borderRadius: 8,
                  borderColor: "#136656",
                  borderWidth: 2,
                  borderStyle: "solid",
                  margin: "0 auto",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                }}
                onClick={() => setShowDeleteHelpGif(true)}
                title="Click to enlarge"
              >
                <img
                  src={deleteGif}
                  alt="Delete an element"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "contain",
                    borderRadius: 12,
                  }}
                />
              </div>
              <Dialog
                visible={showDeleteHelpGif}
                modal
                closable
                header="Delete an element..."
                style={{
                  width: "90vw",
                  maxWidth: "1200px",
                  height: "90vh",
                  maxHeight: "90vh",
                }}
                onHide={() => setShowDeleteHelpGif(false)}
                contentStyle={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  height: "100%",
                }}
              >
                <img
                  src={deleteGif}
                  alt="Delete an element"
                  style={{
                    width: "95%",
                    height: "95%",
                    objectFit: "cover",
                    marginTop: 10,
                    borderRadius: 12,
                    borderColor: "#136656",
                    borderWidth: 2,
                    borderStyle: "solid",
                  }}
                />
              </Dialog>
            </div>
          </div>
        </TabPanel>

        <TabPanel header="Shortcuts">
          <div
            style={{
              padding: "20px",
              maxHeight: "calc(84vh - 240px)",
              overflowY: "auto",
            }}
          >
            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Tab / Shift+Tab - Navigate Nodes
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Press <strong>Tab</strong> to jump to and select the next node,
                or <strong>Shift+Tab</strong> to select the previous node. Nodes
                are navigated from top to bottom, left to right. Once selected,
                you can immediately move the node with arrow keys.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + Enter - Quick Child Creation
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                While editing a node, press <strong>Ctrl+Enter</strong> (or{" "}
                <strong>Cmd+Enter</strong> on Mac) to instantly create a new
                child node in a circular pattern. Perfect for quickly building
                out your map structure! Press <strong>ESC</strong> or click
                anywhere to stop.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Arrow Keys - Move Selected Node
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                With a node selected, use <strong>Arrow Keys</strong> to move it
                by 10 pixels, or <strong>Shift+Arrow Keys</strong> to move it by
                50 pixels. This works when not editing text.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                F2 - Edit Node Text
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                With a node selected, press <strong>F2</strong> to start editing
                the node's text. The input field will be focused and the text
                selected for easy editing.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + N - Open Notes
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                With a node selected, press <strong>Ctrl+N</strong> (or{" "}
                <strong>Cmd+N</strong> on Mac) to open the notes dialog for that
                node. Perfect for quickly adding or editing notes!
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + S - Save
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Press <strong>Ctrl+S</strong> (or <strong>Cmd+S</strong> on Mac)
                to save your map. If the notes dialog is open, it will save just
                the notes instead.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + L - Layout Children
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Select a node and press <strong>Ctrl+L</strong> (or{" "}
                <strong>Cmd+L</strong> on Mac) to automatically arrange all its
                direct children in a beautiful circular pattern around it.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + Shift + L - Layout All Branches
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Select any node and press <strong>Ctrl+Shift+L</strong> (or{" "}
                <strong>Cmd+Shift+L</strong> on Mac) to recursively arrange that
                node and all its child branches. This works through all levels,
                creating a perfectly organized hierarchy!
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + Shift + R - Radial Layout
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Select any node and press <strong>Ctrl+Shift+R</strong> (or{" "}
                <strong>Cmd+Shift+R</strong> on Mac) to arrange all descendants
                in concentric circles. Each depth level forms a ring around the
                center, creating a radial sunburst pattern!
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + Plus (+) - Increase Spacing
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Press <strong>Ctrl++</strong> (or <strong>Cmd++</strong> on Mac)
                to increase the distance between parent and child nodes. If you
                have a node selected, its children will automatically re-arrange
                with the new spacing.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + Minus (-) - Decrease Spacing
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Press <strong>Ctrl+-</strong> (or <strong>Cmd+-</strong> on Mac)
                to decrease the distance between parent and child nodes. If you
                have a node selected, its children will automatically re-arrange
                with the new spacing.
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + Shift + Plus (+) - Increase Global Spacing
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Press <strong>Ctrl+Shift++</strong> (or{" "}
                <strong>Cmd+Shift++</strong> on Mac) to increase the distance
                between ALL node levels across the entire map. This re-layouts
                every branch automatically!
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Ctrl/Cmd + Shift + Minus (-) - Decrease Global Spacing
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Press <strong>Ctrl+Shift+-</strong> (or{" "}
                <strong>Cmd+Shift+-</strong> on Mac) to decrease the distance
                between ALL node levels across the entire map. This compacts the
                entire structure!
              </p>
            </div>

            <div style={{ marginBottom: "24px" }}>
              <div
                style={{
                  fontWeight: "bold",
                  fontSize: "16px",
                  marginBottom: "8px",
                }}
              >
                Shift + Double-Click - Open MS365 Source
              </div>
              <p style={{ marginLeft: "16px", color: "#555" }}>
                Hold <strong>Shift</strong> and <strong>double-click</strong> on
                a node that contains a Microsoft 365 document to open the
                original source document in a new browser tab. Works for emails,
                files, events, and other MS365 content.
              </p>
            </div>

            <div
              style={{
                marginTop: "32px",
                padding: "16px",
                background: "#f0f9f7",
                borderLeft: "4px solid #136656",
                borderRadius: "4px",
              }}
            >
              <strong>💡 Pro Tip:</strong> All layout changes can be undone with{" "}
              <strong>Ctrl+Z</strong> (or <strong>Cmd+Z</strong> on Mac)!
            </div>
          </div>
        </TabPanel>
      </TabView>
    </Dialog>
  );
};

export default Tips;
